import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "tpd-content-layout" }
const _hoisted_2 = { class: "tp-profile-wrapper" }
const _hoisted_3 = { class: "tp-dashboard-tab mb-30" }
const _hoisted_4 = { class: "tp-dashboard-tab-title" }
const _hoisted_5 = { class: "tp-profile-box" }
const _hoisted_6 = { class: "tp-profile-wrap" }
const _hoisted_7 = { class: "tp-profile-info d-flex" }
const _hoisted_8 = { class: "tp-profile-info-tag" }
const _hoisted_9 = { class: "tp-profile-info-details" }
const _hoisted_10 = { class: "tp-profile-info d-flex" }
const _hoisted_11 = { class: "tp-profile-info-tag" }
const _hoisted_12 = { class: "tp-profile-info-details" }
const _hoisted_13 = { class: "tp-profile-info d-flex" }
const _hoisted_14 = { class: "tp-profile-info-tag" }
const _hoisted_15 = { class: "tp-profile-info-details" }
const _hoisted_16 = { class: "tp-profile-info d-flex" }
const _hoisted_17 = { class: "tp-profile-info-tag" }
const _hoisted_18 = { class: "tp-profile-info-details" }
const _hoisted_19 = { class: "tp-profile-info d-flex" }
const _hoisted_20 = { class: "tp-profile-info-tag" }
const _hoisted_21 = { class: "tp-profile-info-details" }
const _hoisted_22 = { class: "tp-profile-info d-flex" }
const _hoisted_23 = { class: "tp-profile-info-tag" }
const _hoisted_24 = { class: "tp-profile-info-details" }
const _hoisted_25 = { class: "tp-profile-info d-flex" }
const _hoisted_26 = { class: "tp-profile-info-tag" }
const _hoisted_27 = { class: "tp-profile-info-details" }
const _hoisted_28 = { class: "d-flex gap-2 p-3" }
const _hoisted_29 = { class: "badge text-light bg-secondary" }
const _hoisted_30 = { class: "tp-profile-info d-flex" }
const _hoisted_31 = { class: "tp-profile-info-tag" }
const _hoisted_32 = { class: "tp-profile-info-details" }
const _hoisted_33 = { class: "details-zone" }
const _hoisted_34 = { class: "table table-sm table-borderless table-list mt-4" }
const _hoisted_35 = {
  class: "font-s-14",
  colspan: "2"
}
const _hoisted_36 = { class: "d-flex align-items-center" }
const _hoisted_37 = { class: "d-block" }
const _hoisted_38 = { class: "text-dark" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", {
  class: "far fa-graduation-cap mr-1",
  style: {"width":"18px","text-align":"center"}
}, null, -1 /* HOISTED */)
const _hoisted_40 = { class: "text-secondary" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", {
  class: "far fa-map-marker-alt mr-1",
  style: {"width":"18px","text-align":"center"}
}, null, -1 /* HOISTED */)
const _hoisted_42 = { class: "text-secondary" }
const _hoisted_43 = { class: "text-secondary" }
const _hoisted_44 = { class: "text-secondary" }
const _hoisted_45 = { class: "table table-sm table-borderless table-list mt-4" }
const _hoisted_46 = {
  class: "font-s-14",
  colspan: "2"
}
const _hoisted_47 = { class: "d-flex align-items-center" }
const _hoisted_48 = { class: "d-block" }
const _hoisted_49 = { class: "text-dark" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("i", {
  class: "far fa-id-card mr-1",
  style: {"width":"18px","text-align":"center"}
}, null, -1 /* HOISTED */)
const _hoisted_51 = {
  key: 0,
  class: "text-secondary"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("i", {
  class: "far fa-map-marker-alt mr-1",
  style: {"width":"18px","text-align":"center"}
}, null, -1 /* HOISTED */)
const _hoisted_53 = { class: "text-secondary" }
const _hoisted_54 = { class: "text-secondary" }
const _hoisted_55 = {
  key: 0,
  class: "text-secondary"
}
const _hoisted_56 = { class: "table table-sm table-borderless table-list mt-4" }
const _hoisted_57 = {
  class: "font-s-14",
  colspan: "2"
}
const _hoisted_58 = { class: "d-flex align-items-center" }
const _hoisted_59 = { class: "d-block" }
const _hoisted_60 = { class: "text-dark" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("i", {
  class: "far fa-file-certificate mr-1",
  style: {"width":"18px","text-align":"center"}
}, null, -1 /* HOISTED */)
const _hoisted_62 = {
  key: 0,
  class: "text-secondary"
}
const _hoisted_63 = { class: "text-secondary" }
const _hoisted_64 = { class: "text-secondary" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" dashboard-content-area-start "),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString($setup.lms_website.__('My Profile')), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", null, _toDisplayString($setup.lms_website.__('Registration Date')), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", null, _toDisplayString($setup.moment($options.auth.user?.creation).format("DD, MMMM YYYY - hh:mm a")), 1 /* TEXT */)
                  ])
                ])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", null, _toDisplayString($setup.lms_website.__('First Name')), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("span", null, _toDisplayString($options.auth.user?.first_name), 1 /* TEXT */)
                  ])
                ])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("span", null, _toDisplayString($setup.lms_website.__('Last Name')), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("span", null, _toDisplayString($options.auth.user?.last_name), 1 /* TEXT */)
                  ])
                ])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("span", null, _toDisplayString($setup.lms_website.__('Username')), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("span", null, _toDisplayString($options.auth.user?.username), 1 /* TEXT */)
                  ])
                ])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("span", null, _toDisplayString($setup.lms_website.__('Email')), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("span", null, _toDisplayString($options.auth.user?.email), 1 /* TEXT */)
                  ])
                ])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("span", null, _toDisplayString($setup.lms_website.__('Phone Number')), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("span", null, _toDisplayString($options.auth.user?.phone), 1 /* TEXT */)
                  ])
                ])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("span", null, _toDisplayString($setup.lms_website.__('Skills')), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.auth?.skills, (skill) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(skill.skill_name), 1 /* TEXT */))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("span", null, _toDisplayString($setup.lms_website.__('Biography')), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("span", _hoisted_33, _toDisplayString($options.auth.user?.bio), 1 /* TEXT */)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("table", _hoisted_34, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, _toDisplayString($setup.lms_website.__('Education Details')), 1 /* TEXT */)
                ])
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.auth?.education, (row) => {
                return (_openBlock(), _createElementBlock("tr", null, [
                  _createElementVNode("td", null, [
                    _createElementVNode("b", _hoisted_37, _toDisplayString(row.institution_name), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_38, [
                      _hoisted_39,
                      _createTextVNode(" " + _toDisplayString(row.major), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _hoisted_41,
                      _createTextVNode(" " + _toDisplayString(row.location), 1 /* TEXT */)
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("b", null, _toDisplayString($setup.lms_website.__('Start Date')) + ":", 1 /* TEXT */),
                      _createTextVNode(" " + _toDisplayString(row.start_date), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("b", null, _toDisplayString($setup.lms_website.__('End Date')) + ":", 1 /* TEXT */),
                      _createTextVNode(" " + _toDisplayString(row.end_date), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("b", null, _toDisplayString($setup.lms_website.__('Grade')) + ":", 1 /* TEXT */),
                      _createTextVNode(" " + _toDisplayString(row.grade), 1 /* TEXT */)
                    ])
                  ])
                ]))
              }), 256 /* UNKEYED_FRAGMENT */))
            ])
          ]),
          _createElementVNode("table", _hoisted_45, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, _toDisplayString($setup.lms_website.__('Work Experience')), 1 /* TEXT */)
                ])
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.auth?.work_experience, (row) => {
                return (_openBlock(), _createElementBlock("tr", null, [
                  _createElementVNode("td", null, [
                    _createElementVNode("b", _hoisted_48, _toDisplayString(row.company), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_49, [
                      _hoisted_50,
                      _createTextVNode(" " + _toDisplayString(row.title), 1 /* TEXT */)
                    ]),
                    (row.location)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                          _hoisted_52,
                          _createTextVNode(" " + _toDisplayString(row.location), 1 /* TEXT */)
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("b", null, _toDisplayString($setup.lms_website.__('Start Date')) + ":", 1 /* TEXT */),
                      _createTextVNode(" " + _toDisplayString(row.from_date), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("b", null, _toDisplayString($setup.lms_website.__('End Date')) + ":", 1 /* TEXT */),
                      _createTextVNode(" " + _toDisplayString((row.current) ? $setup.lms_website.__('Present') : row.to_date), 1 /* TEXT */)
                    ]),
                    (row.description)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_55, _toDisplayString(row.description), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              }), 256 /* UNKEYED_FRAGMENT */))
            ])
          ]),
          _createElementVNode("table", _hoisted_56, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, _toDisplayString($setup.lms_website.__('Certifications')), 1 /* TEXT */)
                ])
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.auth?.certification, (row) => {
                return (_openBlock(), _createElementBlock("tr", null, [
                  _createElementVNode("td", null, [
                    _createElementVNode("b", _hoisted_59, _toDisplayString(row.organization), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_60, [
                      _hoisted_61,
                      _createTextVNode(" " + _toDisplayString(row.certification_name), 1 /* TEXT */)
                    ]),
                    (row.description)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_62, _toDisplayString(row.description), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("b", null, _toDisplayString($setup.lms_website.__('Start Date')) + ":", 1 /* TEXT */),
                      _createTextVNode(" " + _toDisplayString(row.issue_date), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("b", null, _toDisplayString($setup.lms_website.__('End Date')) + ":", 1 /* TEXT */),
                      _createTextVNode(" " + _toDisplayString(row.expiration_date), 1 /* TEXT */)
                    ])
                  ])
                ]))
              }), 256 /* UNKEYED_FRAGMENT */))
            ])
          ])
        ])
      ])
    ]),
    _createCommentVNode(" dashboard-content-area-end ")
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}